module.exports = __webpack_public_path__ + "img/vue2-lacet_vert.37044e94.png";